module.exports = __webpack_public_path__ + "img/profilna.95c74e73.png";